import { OrgFeatureKey } from "@/src/constants/org-features";
import { useOrgFeature } from "@/src/services/organization/org-features.hooks";
import { Redirect } from "expo-router";
import React from "react";

type FeatureGateProps = Readonly<{
  feature: OrgFeatureKey;
  children: React.ReactNode;
}>;

/**
 * Renders `children` only while the org has `feature` switched on. A screen
 * reached by URL while the feature is off goes back to the feed, the same place
 * an unknown route would end up; nothing is shown while the setting loads.
 */
export default function FeatureGate({ feature, children }: FeatureGateProps) {
  const { enabled, isLoading } = useOrgFeature(feature);
  if (isLoading) return null;
  if (!enabled) return <Redirect href="/feeds" />;
  return <>{children}</>;
}
